import type { App } from 'vue'
import type { Router } from 'vue-router'
import { createGtm } from '@gtm-support/vue-gtm'

import appEnv from '@/support/env'

/**
 * Google Tag Manager, pointed at the router so a hash navigation counts as a page view.
 *
 * Guarded: a second `createGtm` installs a second set of router hooks, and every navigation
 * is then reported twice.
 */
let installed = false

export function installGtm(app: App, router: Router) {
  if (installed) return
  installed = true

  if (!appEnv.GA_TAG_ID) return

  app.use(createGtm({ id: appEnv.GA_TAG_ID, vueRouter: router }))
}
